import script from "./InvalidRequest.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvalidRequest.vue?vue&type=script&lang=ts&setup=true"

import "./InvalidRequest.vue?vue&type=style&index=0&id=8403e654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8403e654"]])

export default __exports__